// Dictionary
import { uri } from '../data-util'
import langs from './language.json'

// Builder
import { html, render } from 'lit/html.js'
import 'view-base/unit-link'
import textico from 'url:view-base/type-icon/file-text-o.svg'

// Selector
import { get as val } from 'object-path'
import { provider } from './provider'
import * as serotonerg from '../view-advice-serotonerg'

export function textTable( xeon, state ) {

  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )

  // ------------------------
  // HEAD
  // ------------------------
  const head = []
  const cols = []
  // Score Name
  cols.push( html `<th>${dict["table_score"]}</th>` )
  // Frequency
  cols.push( html `<th>
    <span style="font-size:1.2em;">&sum;</span>
    <span>${dict["table_points"]}</span>
  </th>` )

  for ( const drug of Object.values( xeon.drugs ) ) {
    cols.push( html `<th>${drug.name[lang].substr(0,3)}</th>` )
  }
  // Finalize
  head.push( html `<tr>${cols}</tr>` )

  // ------------------------
  // BODY
  // ------------------------
  const textIcon = { src: textico, cursor: "pointer", fill: "#6CBCFF", className: "hash" }
  const rows = []
  const refs = []

  // ------------------------
  // Serotonerg
  // ------------------------
  const cols1 = []
  cols1.push( html `<td>
    <span style="color:ghostwhite">${dict["table_score1"]}</span>
    <sup>a</sup>
  </td>` )
  // Filter rules
  const sg = data.subgroup()
  // Danger drug score based on subgroup
  const da = data.danger( sg )
  // Answers - { yes:[], no: ["kognitiv.tremor"], unknown: [], missing: [] }
  const as = data.answers()
  // Points
  if ( da >= 3 ) {
    const style = `background:rgba(247,103,158,${Math.min(da/7,0.8)});`
    cols1.push( html `<td style="${style}">${da}</td>` )
  } else {
    cols1.push( html `<td>${da}</td>` )
  }
  // Drugs
  for ( const drug of Object.values( xeon.drugs ) ) {
    if ( sg.mild.includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${1/5});`
      cols1.push( html `<td style="${style}"> + </td>` )
    } else if ( sg.moderate.includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${3/5});`
      cols1.push( html `<td style="${style}"> ++ </td>` )
    } else if ( sg.strong.includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${5/5});`
      cols1.push( html `<td style="${style}"> +++ </td>` )
    } else {
      cols1.push( html `<td> Ø </td>` )
    }
  }
  // Serotonerg row done
  rows.push( html `<tr>${cols1}</tr>` )
  // Legende
  refs.push( html `<span>${dict["sero_prefix"]} </span>` )
  refs.push( html `<span>${dict["sero_limit"]} </span>` )
  if ( as.missing.length > 0 ) {
    refs.push( html `<span>${dict["sero_missing"]}</span>` )
  } else if ( as.yes.length > 0 || as.unknown.length > 0 ) {
    refs.push( html `<span>${dict["sero_precise"]}</span>` )
  }
  refs.push( html `<br>` )

  return html `
    <table class="scores zahl">
      <thead>${ head }</thead>
      <tbody>${ rows }</tbody>
    </table>
    <div class=caption>${ refs }</div>
    `
}